module.exports = __webpack_public_path__ + "img/232.refrigerator.51d5e3f8.svg";